import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { Box, styled } from '@mui/material'
import { TypeSelector } from './TypeSelector'

const StyledContainer = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    height: '40px',
    width: '100%',
    color: '#5d6870',
})

const StyledShapedArrow = styled(Box)({
    height: '20px',
    width: '20px',
    borderLeft: '1px solid #aab0b4',
    borderBottom: '1px solid #aab0b4',
})

const frequencyMap: any = {
    Daily: 1,
    Weekly: 7,
    Monthly: 30,
    Quarterly: 120,
    Yearly: 365,
}

export const TimeRangeSelector = (props: any) => {
    const { noOfDays, handleChange: handleSubmit, loading }: any = props

    const { t } = useTranslation()

    const [selectionType, setSelectionTypeType]: any = useState(null)

    useEffect(() => {
        if (noOfDays === 365) {
            setSelectionTypeType('Yearly')
        } else if (noOfDays === 120) {
            setSelectionTypeType('Quarterly')
        } else if (noOfDays === 30) {
            setSelectionTypeType('Monthly')
        } else if (noOfDays === 7) {
            setSelectionTypeType('Weekly')
        } else {
            setSelectionTypeType('Daily')
        }
    }, [noOfDays])

    const handleTypeChange = (value: any) => {
        setSelectionTypeType(value)
        handleSubmit(frequencyMap[value])
    }

    return (
        <StyledContainer data-ai-explain="Digest email: how often to send summary reports">
            <Box display="flex" alignItems="flex-start" height="100%">
                <StyledShapedArrow />
            </Box>
            <Box paddingX="8px">{t('SendReminder')}</Box>

            <Box width="100px" marginX="8px">
                <TypeSelector
                    value={selectionType}
                    handleChange={handleTypeChange}
                    loading={loading}
                    ariaLabel={t('SendReminder')}
                />
            </Box>
        </StyledContainer>
    )
}
